import React, {Component} from 'react';
import items from '../../assets/json/tftitems.json';

class ItemImage extends Component{
    render() {
        if(this.props.name != null) {
            const myImage = `/icons/${this.props.name}.png`
            return (<img title={items.find((item) => item.id === this.props.name).name} alt={items.find((item) => item.id === this.props.name).name} className={`${this.props.size == null ? 'item' : 'item-large'} rounded border border-yellow-500`} src={myImage}/>)
        } else {
			return (
				<div className="flex justify-center justify-items-stretch">
					<div className="w-16 h-16 border-b-2 border-white-900 rounded-full animate-spin"></div>
				</div>
			)
		}
    }
}
export default ItemImage